/** Searchable text for one donation row — mirrors the visible columns. */
export function donationSearchParts(d, deps) {
    return [
        d.donorName,
        d.campaignName,
        d.label,
        deps.formatAmount(d.amount, d.currency),
        d.donationType ? deps.t(`finance.donations.type.${d.donationType}`) : "",
        d.paymentMethod ? deps.t(`finance.donations.paymentMethod.${d.paymentMethod}`) : "",
        d.status ? deps.t(`finance.donations.status.${d.status}`) : "",
        deps.formatDate(d.donationDate),
    ];
}
/** Searchable text for one subscription row — mirrors the visible columns. */
export function subscriptionSearchParts(s, deps) {
    return [
        s.id,
        s.donorName,
        deps.formatAmount(s.initialAmount ?? 0, s.currency),
        deps.formatAmount(s.amount, s.currency),
        s.frequency ? deps.t(`finance.subscriptions.frequency.${s.frequency}`) : "",
        s.status ? deps.t(`finance.subscriptions.status.${s.status}`) : "",
    ];
}
